module.exports = __webpack_public_path__ + "img/30f2.6b5351c6.jpg";